// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__F5ANX","list":"PatternAutocomplete_list__1HU3n"};